import { Injectable } from '@angular/core';
import {
  EntityState,
  EntityStore,
  EntityUIStore,
  getEntityType,
  StoreConfig,
} from '@datorama/akita';

import { BudgetForecastSetting } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type ForecastSettingsModel = getEntityType<ForecastSettingsState>;

export type ForecastSettingsState = EntityState<
  RequireSome<Partial<BudgetForecastSetting>, 'amount_type' | 'id' | 'override'> & {
    total_accrual: number;
    total_cost: number;
    total_forecast: number;
    total_override: number;
    total_wp: number;
    unit_cost: number;
  }
>;

export type ForecastSettingsUI = {
  errorMessage?: string;
  id?: string;
  showError: boolean;
  unforecasted: boolean;
};

export type ForecastSettingsUIState = EntityState<ForecastSettingsUI>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'forecast-settings' })
export class ForecastSettingsStore extends EntityStore<ForecastSettingsState> {
  ui!: EntityUIStore<ForecastSettingsUIState>;

  constructor() {
    super({});

    const defaultUiState: ForecastSettingsUI = {
      showError: false,
      unforecasted: false,
    };

    this.createUIStore().setInitialEntityState(defaultUiState);
  }
}
